import { createNS } from "@ontologies/core";

const wikibase = createNS("http://wikiba.se/ontology-beta#");

export default {
  ns: wikibase,
};
